import { IonText } from '@ionic/react';
import { ReactElement } from 'react';
import i18n from '../../../i18n';

const ScratchpadNoPartsFiltered = (): ReactElement => {
  return (
    <div className="full-height-width content-center">
      <IonText className="ion-padding ion-text-center" color="medium">
        <div>{i18n.t('common:scratchpad_no_results_found')}</div>
      </IonText>
    </div>
  );
};

export { ScratchpadNoPartsFiltered };
